export const SETTLEMENT_STATUS = {
  SETTLED: 'SETTLED',
  UNSETTLED: 'UNSETTLED',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  MOVED: 'MOVED',
  FAILURE: 'FAILURE',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
  FAIL: 'FAIL',
  UNIDENTIFIED: 'UNIDENTIFIED',
  APPROVED: 'APPROVED',
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  IN_PROGRESS: 'IN_PROGRESS',
  IN_PROGRESS_ALT: 'IN PROGRESS',
  NEW: 'NEW',
  RETRYING: 'RETRYING',
};

export const CONFIRM_MSG = 'Are you sure you want to continue?';
export const CONFIRM_RETRY_MSG =
  "This action will initiate a new settlement request. Please verify the merchant's statement before proceeding to submit for approval.";
export const CONFIRM_TRANSFER_MSG =
  'This will group transactions into a new batch for settlement processing. Verify the transaction status on bank/merchant statements before proceeding to submit for approval.';
